export default __webpack_public_path__ + "static/media/AJAX_blog.9b28b2ab.png";